import { get, post, put, postAbs, putAbs } from "./http";

// Mirrors ordr-flutter lib/network/repository.dart auth section
export const login = (email, password) => post("/auth/login", { email, password });

export const registerBuyer = (payload) => post("/auth/registerBuyer", payload);

export const sendOtp = (payload) => post("/auth/sendOTP", payload);
export const resendOtp = (payload) => post("/auth/sendOTP", payload);
export const verifyOtpBuyer = (payload) => post("/auth/verifyOTPBuyer", payload);
export const verifyOtpForgetPassword = (payload) => post("/auth/verifyOTPForgetPassword", payload);
export const changeForgetPassword = (payload) => post("/auth/changeForgetPassword", payload);

// Backend expects POST { zipCode }; callers may pass a bare zip or { zip }.
export const detailByZip = (zip) => post("/auth/detailByZip", { zipCode: typeof zip === "object" ? zip.zip : zip });
export const getUser = () => get("/auth/user");
export const updateUser = (payload) => put("/auth/user", payload);
export const uploadProfilePic = (formData) =>
	post("/auth/profilePic", formData, { "Content-Type": "multipart/form-data" });

export const registerCompany = (payload) => postAbs("/v2/buyer/company", payload);
export const updateCompany = (payload) => putAbs("/v2/buyer/company", payload);

export const constantCollections = () => get("/buyer/constantCollections");
